import { render } from "./SchedaVisualizzazioneProgetto.vue?vue&type=template&id=486c3458"
import script from "./SchedaVisualizzazioneProgetto.vue?vue&type=script&lang=js"
export * from "./SchedaVisualizzazioneProgetto.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__